import styled, {css} from 'styled-components';
import { checkNested } from 'components/utils';

const baseHeadingStyles = css`
  display: ${(props) => props.display};
  font-family: ${(props) => props.fontFamily};
  text-align: ${(props) => props.align};
  text-transform: ${(props) => props.textTransform};
  letter-spacing: ${(props) => props.letterSpacing};
  color: ${(props) => props.color || 'inherit'};
  margin-top: ${(props) => props.marginTop};
  margin-bottom: ${(props) => props.marginBottom};
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  ${(props) => props.fontWeight && `font-weight: ${props.fontWeight};`}

  ${(props) =>
    props.truncate &&
    `
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `}
`;

const StyledHeading = styled.h1`
    ${baseHeadingStyles}
    font-size: ${(props) =>
        (checkNested(props.theme, 'typography', 'heading', props.level, 'fontSize') &&
            props.theme.typography.heading[props.level].fontSize.xxs) ||
        ''};
    line-height: ${(props) =>
        (checkNested(props.theme, 'typography', 'heading', props.level, 'lineHeight') &&
            props.theme.typography.heading[props.level].lineHeight.xxs) ||
        ''};
    @media screen and (min-width: ${(props) => props.theme.breakpoints && props.theme.breakpoints.xs}) {
        font-size: ${(props) =>
        (checkNested(props.theme, 'typography', 'heading', props.level, 'fontSize') &&
            props.theme.typography.heading[props.level].fontSize.xs) ||
        ''};
        line-height: ${(props) =>
        (checkNested(props.theme, 'typography', 'heading', props.level, 'lineHeight') &&
            props.theme.typography.heading[props.level].lineHeight.xs) ||
        ''};
        }
    @media screen and (min-width: ${(props) => props.theme.breakpoints && props.theme.breakpoints.sm}) {
        font-size: ${(props) =>
        (checkNested(props.theme, 'typography', 'heading', props.level, 'fontSize') &&
            props.theme.typography.heading[props.level].fontSize.sm) ||
        ''};
        line-height: ${(props) =>
        (checkNested(props.theme, 'typography', 'heading', props.level, 'lineHeight') &&
            props.theme.typography.heading[props.level].lineHeight.sm) ||
        ''};
        }
    @media screen and (min-width: ${(props) => props.theme.breakpoints && props.theme.breakpoints.md}) {
        font-size: ${(props) =>
        (checkNested(props.theme, 'typography', 'heading', props.level, 'fontSize') &&
            props.theme.typography.heading[props.level].fontSize.md) ||
        ''};
        line-height: ${(props) =>
        (checkNested(props.theme, 'typography', 'heading', props.level, 'lineHeight') &&
            props.theme.typography.heading[props.level].lineHeight.md) ||
        ''};
        }
    @media screen and (min-width: ${(props) => props.theme.breakpoints && props.theme.breakpoints.lg}) {
        font-size: ${(props) =>
        (checkNested(props.theme, 'typography', 'heading', props.level, 'fontSize') &&
            props.theme.typography.heading[props.level].fontSize.lg) ||
        ''};
        line-height: ${(props) =>
        (checkNested(props.theme, 'typography', 'heading', props.level, 'lineHeight') &&
            props.theme.typography.heading[props.level].lineHeight.lg) ||
        ''};
        }
    @media screen and (min-width: ${(props) => props.theme.breakpoints && props.theme.breakpoints.xl}) {
        font-size: ${(props) =>
        (checkNested(props.theme, 'typography', 'heading', props.level, 'fontSize') &&
            props.theme.typography.heading[props.level].fontSize.xl) ||
        ''};
        line-height: ${(props) =>
        (checkNested(props.theme, 'typography', 'heading', props.level, 'lineHeight') &&
            props.theme.typography.heading[props.level].lineHeight.xl) ||
        ''};
        }
`;

export default StyledHeading;